import type * as React from "react";
import type { SVGProps } from "react";

export function Loading({
  width = 24,
  height = 24,
  dur = "0.75s",
}: SVGProps<SVGElement>): React.JSX.Element {
  return (
    <svg
      aria-label="Loading indicator"
      className="fill-current"
      height={height}
      role="img"
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Loading</title>
      <circle cx="4" cy="12" r="3">
        <animate
          attributeName="r"
          begin="0;b.end-0.25s"
          dur={dur}
          id="a"
          values="3;.2;3"
        />
      </circle>
      <circle cx="12" cy="12" r="3">
        <animate
          attributeName="r"
          begin="a.end-0.6s"
          dur={dur}
          values="3;.2;3"
        />
      </circle>
      <circle cx="20" cy="12" r="3">
        <animate
          attributeName="r"
          begin="a.end-0.45s"
          dur={dur}
          id="b"
          values="3;.2;3"
        />
      </circle>
    </svg>
  );
}
